import { MEDIA_NAME } from '../types/types';
import { putUserCert } from '../../infra/api/putUserCert';
import { useBridge } from './useBridge';
import { getUserCertComplete } from '../../infra/api/getUserCertComplete';
import { mutateHouseCert } from '../../infra/api/mtg/mutateHouseCert';
import { fetchHouseCertCheck } from '../../infra/api/mtg/fetchHouseCertCheck';

interface ICertResponse {
  isSucceed: boolean;
  resultCode?: string;
  resultMessage?: string;
  txSeqNo?: string;
  appToken?: string;
}

const useCert = (media?: string, ref_page?: boolean) => {
  const br: any = useBridge();

  const reqCert = async (params: any) => {
    if (ref_page) {
      return await mutateHouseCert(params);
    } else {
      return await putUserCert(params);
    }
  };

  const reqCertKt = async (params: any) => {
    const result: any = await reqCert(params);
    if (result?.data?.isSucceed) {
      return new Promise((resolve) => {
        br.onReceiveAuthCheck((pisAppToken: any, isSuccess: any) => {
          console.log(`${pisAppToken} ${isSuccess}`);
          resolve(result);
        });
        if (process.env.REACT_APP_ENV !== 'production') {
          br.requestAuthCheck({ pisAppToken: result?.data?.result?.txSeqNo });
        } else {
          br.requestAuthCheck({ pisAppToken: result?.data?.result?.appToken });
        }
      });
    } else {
      return result;
    }
  };

  const checkCertComp = async (payload: any) => {
    if (ref_page) {
      const result: any = await fetchHouseCertCheck(payload);
      return result;
    } else {
      const result: any = await getUserCertComplete(payload);
      return result;
    }
  };

  return {
    reqCert: media === MEDIA_NAME.KT ? reqCertKt : reqCert,
    checkCertComp: checkCertComp,
  };
};

export default useCert;
